import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export interface BulkConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  names: string[];
  skipCount: number;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const BulkConfirmDialog: React.FC<BulkConfirmDialogProps> = ({
  open,
  title,
  description,
  names,
  skipCount,
  confirmLabel,
  onConfirm,
  onCancel,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <ul className="max-h-48 list-disc overflow-y-auto rounded-md border bg-muted/30 p-2 pl-6 text-sm">
          {names.map((n) => (
            <li key={n} className="py-0.5">{n}</li>
          ))}
        </ul>
        {skipCount > 0 ? (
          <p className="text-sm text-muted-foreground">
            {skipCount === 1
              ? '1 selected connector is already disabled and will be skipped.'
              : `${skipCount} selected connectors are already disabled and will be skipped.`}
          </p>
        ) : null}
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
